export default "__VITE_ASSET__7PQBXyqJ__"